'use strict';

module.exports = require('affirm/vcn');
